import { api } from "./axios";

export interface CustomPackage {
  email: string;
  credits: number;
  price: number;
  expiryDate: string;
  description: string;
}

export interface StripePrice {
  id: string;
  object: string;
  active: boolean;
  billing_scheme: string;
  created: number;
  currency: string;
  unit_amount: number;
  unit_amount_decimal: string;
  type: string;
  recurring: {
    interval: string;
    interval_count: number;
    usage_type: string;
  } | null;
  metadata: {
    [key: string]: any;
  };
}

export interface StripeProduct {
  id: string;
  name: string;
  description: string | null;
  active: boolean;
  metadata: {
    payment_link?: string;
    pitch_limit?: string;
    credits?: string;
    product_id?: string;
    [key: string]: any;
  };
  default_price: string | null;
  prices: StripePrice[];
}

export interface Permission {
  id: number;
  name: string;
}

export interface PackageLimitPermission {
  permission_id: number;
  limit: number | null;
}

export interface PackageLimitsPayload {
  packageId: string;
  planName: string;
  permissions: PackageLimitPermission[];
}

export const customPackageApi = {
  // Create a custom subscription package
  createPackage: (data: CustomPackage) =>
    api.post("/admin/custom-subscription", data),

  // Get all Stripe products
  getAllStripeProducts: () =>
    api.get("/stripe/products"),

  // Get all custom packages (already exists in admin.ts, included here for completeness)
  getAllCustomPackages: () =>
    api.get("/admin/get-all-custom-packages"),

  // Get all permissions
  getAllPermissions: () =>
    api.get("/admin/get-all-permissions"),

  // Add package limits
  addPackageLimits: (data: PackageLimitsPayload) =>
    api.post("/admin/add-package-limits", data),


  updatePackageLimits: (id: string | number, data: PackageLimitsPayload) =>

    api.put(`/admin/package-limits-update/${id}`, data),
};
